import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthService, ScreenService, AppInfoService, ThemeService } from './services';
import { KeycloakService } from 'keycloak-angular';
import { HealthCheckService } from './services/health-check.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  authenticated = false;

  constructor(private readonly keycloak: KeycloakService,
              private screen: ScreenService, 
              public appInfo: AppInfoService, 
              private themeService: ThemeService,
              private healthCheckService: HealthCheckService) {
                
            themeService.setAppTheme();
  }

  ngOnInit() {
    if (this.keycloak.isLoggedIn()) {
      this.keycloak.getToken().then(t => sessionStorage.setItem('token', t));
    }
  }

  checkHealth(): void {
    this.healthCheckService.checkHealth().subscribe(response => {
      console.log('Server health:', response);
    });
  }

  isAuthenticated() {
    return this.keycloak.isLoggedIn();
  }

}
